import { useState } from "react";
import logo from "../assets/burgersson-logo.png";

const menuData = {
  burgare: [
    {
      section: null,
      items: [
        {
          name: "Classic",
          price: "145:-",
          description:
            "Svenskt nötkött / amerikansk cheddar / picklad gurka / silverlök / ketchup & senap",
        },
        {
          name: "Bacon & Cheese",
          price: "149:-",
          description:
            "Svenskt nötkött / amerikansk cheddar / bacon / karamelliserad lök / ketchup / senap",
        },
        {
          name: "Chili",
          price: "149:-",
          description:
            "Svenskt nötkött / amerikansk cheddar / chilimayo / picklad chili / picklad gurka / krispsallad",
        },
        {
          name: "Truffle Pig",
          price: "149:-",
          description:
            "Svenskt nötkött / tryffelmayo / bacon / cheddarost / picklad rödlök",
        },
        {
          name: "Smash n Grab",
          price: "155:-",
          description:
            "Svenskt nötkött 2 x 80g / bread & butter pickles / chipotlemayo / 2 x americans cheddarost / bacon",
        },
        {
          name: "Ginger Spice (Veg/Vegan)",
          price: "149:-",
          description:
            "peas of Heaven burgare / soya & misomayo / gurka picklad i ingefära, sesam & koriander / cheddar / sriracha (för vegan beställ även vårat vegan bröd och utan ost)",
        },
        {
          name: "Barnburgare",
          price: "95:-",
          description:
            "Svenskt nötkött, välj själva om ni vill ha ost, bacon, ketchup & senap. Serveras med pommes (går även att få som vegetarisk/vegan)",
          fullWidth: true,
        },
      ],
    },
    {
      section: "Sallader",
      items: [
        {
          name: "Chicken Caesar Sallad",
          price: "169:-",
          description:
            "Romansallad / Caesar dressing / tomat / rödlök / kyckling / bacon / krutonger",
        },
      ],
    },
    {
      section: "Sides",
      items: [
        { name: "Pommes", price: "55:-", description: "Klassiska pommes" },
        {
          name: "Västerbottenpommes",
          price: "65:-",
          description: "Pommes slungade i västerbottensost & örter",
        },
        {
          name: "Caesar Sallad",
          price: "55:-",
          description: "romansallad / caesar dressing / tomat / rödlök",
        },
        {
          name: "Dippsåser / Dipp-Bricka",
          price: "",
          description:
            "(4st valfria dipper)\nChilimayo / Aioli (vegan) / Tryffelmayo / Chipotlemayo / Cheddardipp",
          fullWidth: true,
        },
      ],
    },
  ],
  shakes: [
    {
      section: "Milkshakes",
      items: [
        {
          name: "Sea Salt Caramel",
          price: "69:-",
          description: "Gjord på Lejonet & Björnens Sea Salted Caramel glass",
        },
        {
          name: "Banan & Choklad",
          price: "69:-",
          description: "Gjord på Lejonet & Björnens Banan & Choklad glass",
        },
        {
          name: "Hallon",
          price: "69:-",
          description: "Gjord på Lejonet & Björnens Hallonsorbet",
        },
      ],
    },
    {
      section: "Alco-Shakes",
      items: [
        {
          name: "The Rum Diary",
          price: "125:-",
          description:
            "Gjord på Lejonet & Björnens Sea Salted Caramel glass, toppad med Kahlua & Diplomatico",
        },
        {
          name: "Go Bananas",
          price: "125:-",
          description:
            "Gjord på Lejonet & Björnens Banan & Choklad glass, toppad med Bulleit Bourbon",
        },
        {
          name: "Kapten Hallon",
          price: "125:-",
          description:
            "Gjord på Lejonet & Björnens Hallonsorbet, toppad med Cpt. Morgan Gold",
        },
      ],
    },
  ],
  sott: [
    {
      section: null,
      items: [
        {
          name: "Kladdkaka",
          price: "55:-",
          description: "Serveras med grädde",
        },
        {
          name: "Glasskula",
          price: "39:-",
          description: "Sea salted caramel / Banan & Choklad / Hallonsorbet",
        },
      ],
    },
  ],
  dryck: [
    {
      section: "Alkoholfritt",
      items: [
        {
          name: "Alkoholfri Hantverksöl 0,5%",
          price: "69:-",
          description: null,
        },
        { name: "Peroni Libera 0%", price: "59:-", description: null },
        { name: "Alkoholfritt Bubbel", price: "69:-", description: null },
        { name: "Virgin Mary", price: "69:-", description: null },
        {
          name: "Pepsi / Pepsi Max / Zingo / 7UP / Loka",
          price: "5:-",
          description: null,
        },
        { name: "Kallpressad Juice", price: "45:-", description: null },
        { name: "Kaffe", price: "45:-", description: null },
        { name: "Te", price: "45:-", description: null },
      ],
    },
    {
      section: "Öl",
      items: [
        { name: "Fat: Gambrinus", price: "74:-", description: null },
        { name: "Fat: Gästfat", price: "85:-", description: null },
        {
          name: "Peroni / Hink 5st Peroni",
          price: "69:- / 295:-",
          description: null,
        },
        { name: "Glutenfri Öl", price: "75:-", description: null },
        { name: "Crabbies Ginger Beer", price: "79:-", description: null },
        { name: "Somersby Päroncider", price: "69:-", description: null },
      ],
    },
    {
      section: "Vin",
      items: [
        { name: "Husets Röda", price: "89:- / 295:-", description: null },
        { name: "Husets Vita", price: "89:- / 295:-", description: null },
        { name: "Rosè", price: "89:- / 295:-", description: null },
      ],
    },
  ],
};

const tabs = [
  { key: "burgare", label: "Burgare" },
  { key: "shakes", label: "Shakes" },
  { key: "sott", label: "Sött" },
  { key: "dryck", label: "Dryck" },
];

const MenuSection = () => {
  const [active, setActive] = useState("burgare");

  return (
    <section
      id="menu"
      className="relative bg-background py-24 px-6 md:px-16 overflow-hidden"
    >
      {/* Repeating logo background */}
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden="true"
        style={{
          backgroundImage: `url(${logo})`,
          backgroundRepeat: "repeat",
          backgroundSize: "cover",
          opacity: 0.05,
          filter: "grayscale(100%)",
        }}
      />

      <div className="max-w-5xl mx-auto relative z-10">
        <h2
          className="font-heading text-2xl md:text-4xl tracking-wide text-foreground uppercase text-center mb-5"
          style={{ lineHeight: "1.15" }}
        >
          Menu
        </h2>
        <p className="font-body text-sm text-muted-foreground text-center max-w-2xl mx-auto mb-12 leading-relaxed">
          Vår meny varierar från klassiska till lite mer experimentella burgare
          och sides.
        </p>

        {/* Tabs */}
        <div className="flex items-center justify-center gap-2 md:gap-3 mb-14">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActive(tab.key)}
              className={`px-5 py-2 rounded-full text-xs font-body font-medium uppercase tracking-widest transition-all duration-300 border ${
                active === tab.key
                  ? "bg-foreground text-background border-foreground"
                  : "border-foreground/30 text-foreground hover:bg-foreground/10"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Menu Content */}
        {menuData[active].map((group, gi) => (
          <div key={gi} className="mb-12">
            {/* Section heading */}
            {group.section && (
              <div className="text-center mb-10">
                <h3
                  className="font-heading text-lg md:text-xl tracking-widest text-foreground uppercase inline-block pt-2 border-t border-foreground/40 pb-2"
                  style={{ lineHeight: "1.15" }}
                >
                  {group.section}
                </h3>
              </div>
            )}

            {/* Items grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
              {group.items.map((item) => (
                <div
                  key={item.name}
                  className={`border-border pb-6 ${item.fullWidth ? "md:col-span-2 lg:col-span-3" : ""}`}
                >
                  <div className="flex items-baseline justify-between mb-2">
                    <h3
                      className="font-heading text-base tracking-wide text-foreground uppercase"
                      style={{ lineHeight: "1.35" }}
                    >
                      {item.name}
                    </h3>
                    {item.price && (
                      <span className="font-heading text-base text-primary font-semibold ml-4 shrink-0">
                        {item.price}
                      </span>
                    )}
                  </div>
                  {item.description && (
                    <p className="font-body text-xs text-muted-foreground leading-relaxed whitespace-pre-line">
                      {item.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Bottom Buttons */}
        <div className="flex items-center justify-center gap-4 mt-14">
          <a
            href="/burgersson-menu.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2.5 border border-foreground/40 text-xs font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
          >
            PDF Menu
          </a>
          <a
            href="https://hey.hn/sksln"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2.5 border border-foreground/40 text-xs font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
          >
            Beställ Mat
          </a>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
